// assets/hbk-footer.js
(function () {
  'use strict';

  function initAccordions(scope) {
    var root = scope || document;
    root.querySelectorAll('.hbk-ft__col-toggle, .hbk-ft__brand-toggle').forEach(function (btn) {
      if (btn.dataset.ftBound) return;
      btn.dataset.ftBound = '1';
      btn.addEventListener('click', function () {
        if (window.innerWidth >= 750) return;
        var col = btn.closest('.hbk-ft__col');
        var isOpen = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initAccordions(document); });
  document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.hbk-ft__col-toggle, .hbk-ft__brand-toggle').forEach(function (btn) {
      delete btn.dataset.ftBound;
    });
  });

})();
